import { ZoomInIcon, ZoomOutIcon } from '../icons/Icons'
import styles from './ZoomControls.module.css'

interface ZoomControlsProps {
  level: number
  onZoomIn?: () => void
  onZoomOut?: () => void
}

export function ZoomControls({ level, onZoomIn, onZoomOut }: ZoomControlsProps) {
  return (
    <div className={styles.controls}>
      <button className={styles.btn} onClick={onZoomOut}>
        <ZoomOutIcon className={styles.icon} />
      </button>
      <span className={styles.level}>{level}%</span>
      <button className={styles.btn} onClick={onZoomIn}>
        <ZoomInIcon className={styles.icon} />
      </button>
    </div>
  )
}
